import { Injectable, Injector, Signal, signal } from '@angular/core'
import { BaseAction } from '../models/base-action.model'
import { QUICK_ACTION_PROVIDER } from '../constants/quick-action-provider.const'
import { BaseQuickActionProvider } from '../models/base-quick-action-provider.model'
import { Observable, of } from 'rxjs'
import { catchError } from 'rxjs/operators'

@Injectable({ providedIn: 'root' })
export class ActionRegistryService {
	private providers = new Map<string, BaseQuickActionProvider>()

	constructor(private injector: Injector) {}

	getProviderByPrefix(prefix: string): BaseQuickActionProvider | null {
		let provider = this.providers.get(prefix)

		if (!provider) {
			const providers = this.injector.get<BaseQuickActionProvider[]>(
				QUICK_ACTION_PROVIDER,
				[],
			)

			provider = providers.find((p) => p.prefix === prefix) || null

			this.providers.set(prefix, provider)
		}

		return provider
	}

	searchByPrefix(prefix: string, query: string): Observable<BaseAction[]> {
		const provider = this.getProviderByPrefix(prefix)

		if (!provider) return of([])

		return provider.search(query).pipe(catchError(() => of([])))
	}

	getProviderHelperByPrefix(prefix: string): Observable<string> {
		const provider = this.getProviderByPrefix(prefix)

		if (!provider) return of('')

		return provider.getPrefixHelper().pipe(catchError(() => of('')))
	}

	register(provider: BaseQuickActionProvider): void {
		const existing = this.providers.get(provider.prefix)

		//TODO: Consider supporting multiple provider for same prefix
		if (existing) {
			console.warn(
				`Registration of same prefix provider. Skipping ${provider.prefix}`,
			)
			return
		}

		this.providers.set(provider.prefix, provider)
	}
}
